import type React from 'react';
import loadable from '@loadable/component';

const MapWrapper = loadable(
  () => import(/* webpackChunkName: "MapWrapper.loadable" */ 'app/shared/wrappers/MapWrapper/component'),
);

interface LoadableMapWrapperProps {
  useStaticMap?: boolean;
  setIsMwebMapLoaded?: ((loaded: boolean) => void) | null;
}

const LoadableMapWrapper: React.FC<LoadableMapWrapperProps> = (props) => {
  return <MapWrapper {...props} />;
};

export default LoadableMapWrapper;
